{
  "version": 1,
  "asset_id": "dc2e6926-2d95-43eb-a4b5-57ea6ada7115",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/dc2e6926-2d95-43eb-a4b5-57ea6ada7115/sleeve-fitzer-1-440.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/dc2e6926-2d95-43eb-a4b5-57ea6ada7115/sleeve-fitzer-1-440.png",
  "original_filename": "sleeve-fitzer-1-440.png",
  "size": 107558,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:43Z"
}
